// extracted by mini-css-extract-plugin
export default {"divBackground":"LoadingScreen_divBackground__COIQ4","spinner":"LoadingScreen_spinner__5cPUS"};